/**
 * Modos de gravação das alterações feitas nas camadas do mapa.
 */
export enum AnalysisSavingMode {

    /** Salvar as alterações das camadas na própria análise atual. */
    SAVE_IN_CURRENT_ANALYSIS = 1,

    /** Salvar as alterações das camadas em uma nova análise. */
    SAVE_IN_NEW_ANALYSIS = 2,

    /** Salvar as alterações das camadas em um novo projeto. */
    SAVE_IN_NEW_PROJECT = 3
}